import React, { useState, memo, useEffect } from 'react';
import AccessControl from '../../../../shared/components/AccessControl';
import DataTable from '../../../../shared/components/DataTable';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Card, CardBody, Col, ButtonToolbar, Badge } from "reactstrap";
import CustomSearch from './CustomSearch';
import { reset } from 'redux-form';
import { permissionsConstants } from '../../../../constants/permission.constants';
import Tabs from "../../../../shared/components/Tab/Tabs";
import "../../../../shared/components/Tab/tab.css";
import DisbursementModal from "./modal/DisbursementModal";
import { disbursementAction } from '../../actions/disbursement.actions';

const {
    CREATE_DISBURSEMENT,
    VIEW_DISBURSEMENT,
  } = permissionsConstants;

const DisbursementTable = memo((props) => {
    const { dataState, fetchData, disbursements, dispatch } = props;
    const [showModal, setShowModal] = useState(false);
    const [disbursementInview, setDisbursementInview] = useState("");
    const [searchKey, setSearchKey] = useState("");
    const [currentTab, setCurrentTab] = useState(0);
    const [loader, setLoader] = useState(0);

    const clearModal = () => {
        setShowModal(false);
        setDisbursementInview("")
    };
    useEffect(() => {
        if(!showModal) setDisbursementInview("")
    }, [showModal])

    const reviewDisbursement = async (action, comment) => {
        
        setLoader(action)
        const requestParams = dataState?.request;
        try {
            await dispatch(disbursementAction(disbursementInview, action, comment, clearModal, requestParams ));
            setLoader(0)
        } catch (error) {
            setLoader(0)
            console.error(error)
        }
        
    }
    const toggleTabs = (currentTab) => {
        if(currentTab === 0) {
            fetchData({
                ...dataState.request,
                searchKey: searchKey,
                status: ''
            })
        } else if(currentTab === 1) {
            fetchData({
                ...dataState.request,
                searchKey: searchKey,
                status: 'pending_review'
            })
        } else if(currentTab === 2) {
            fetchData({
                ...dataState.request,
                searchKey: searchKey,
                status: 'approved'
            })
        } else if(currentTab === 3) {
            fetchData({
                ...dataState.request,
                searchKey: searchKey,
                status: 'rejected'
            })
        } else if(currentTab === 4) {
            fetchData({
                ...dataState.request,
                searchKey: searchKey,
                status: 'redraft'
            })
        }
    };

    useEffect(() => {
        toggleTabs(currentTab);
    }, [currentTab])

    const count = dataState && dataState.response ? dataState.response.count : 0;
    
    const sortFn = (pageNum, pageSize, column) => {
        let sortOrder = "ASC";
        if (!disbursements.loading) {
            if (disbursements.request && disbursements.request.sortOrder) {
                sortOrder = disbursements.request.sortOrder === "ASC" ? "DESC" : "ASC";
            }
            fetchData({
                ...disbursements.request,
                pageNum,
                pageSize,
                sortKey: column.sortKey,
                sortOrder,
            });
        }
    };
    const handleSubmit = (values) => {
        setSearchKey(values.searchKey);
        let pageNum;
        if(disbursements && disbursements.request && disbursements.request.searchKey !== values.searchKey) pageNum = 1;
        fetchData({
            ...disbursements.request,
            pageNum: pageNum,
            searchKey: values.searchKey || "",
        });
    };
    const clearForm = () => {
        dispatch(reset("custom_search"));
        setSearchKey("")
    }
    const loadData = (pageNum, pageSize) => {
        fetchData({
            ...dataState.request,
            pageNum,
            pageSize,
            searchKey: searchKey,
        });
    };
    const disbursementModal = (status, id) => {
        setDisbursementInview(id);
        setShowModal(true);
    };
    const columns = [
        {
            accessor: "batchName",
            name: "Batch Name",
            filterable: true,
            sortable: true,
            sortKey: "batchName",
            Cell: (row) => <span>{row.batchName}</span>
        },
        {
            accessor: "numberOfRecipients",
            name: "No of Recipients",
            filterable: true,
            sortable: true,
            sortKey: "numberOfRecipients",
            show: true,
            Cell: (row) => <span>{row.numberOfRecipients}</span>
        },
        {
            accessor: "createdOn",
            name: "Creation Date",
            filterable: true,
            sortable: true,
            sortKey: "createdOn",
            show: true,
            Cell: (row) => <span>{row.createdOn}</span>,
        },
        {
            accessor: "createdBy",
            name: "Created By",
            sortable: true,
            sortKey: "createdBy",
            filterable: true,
            show: true,
            Cell: (row) => <span>{row.createdBy}</span>,
        },
        {
            accessor: "status",
            name: "Status",
            sortable: true,
            sortKey: "status",
            filterable: true,
            show: true,
            Cell: (row) => <Badge color={statusColorPallete(row.status)}>{row.status}</Badge>,
        },
        {
            accessor: "viewDisbursement",
            name: "",
            sortable: true,
            sortKey: "active",
            filterable: true,
            Cell: row => <div style={{color: '#62b7fc'}} onClick={() => disbursementModal(row.status, row.id)}>View</div>
        }
    ];
    const statusColorPallete = status => {
        if(status){
            if(status === "approved") {
                return "success"
            } else if (status === "pending_review") {
                return "info"
            } else if (status === "rejected") {
                return "danger"
            } else {
                return "warning"
            }
        }
    }

    const onTabChange = (index, value) => {

        setCurrentTab(value)
    }

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="card__title">
                        <AccessControl
                            allowedPermissions={[CREATE_DISBURSEMENT]}
                            renderNoAccess={() => null}
                        >
                            <ButtonToolbar className="products-list__btn-toolbar-top">
                                <Link
                                    className="btn btn-primary products-list__btn-add"
                                    to="/disbursement/add"
                                    id="link-create-user"
                                    style={{ width: "12rem" }}
                                >
                                    Create Disbursement
                                </Link>
                            </ButtonToolbar>
                        </AccessControl>
                    </div>
                    <br />
                    <AccessControl
                            allowedPermissions={[VIEW_DISBURSEMENT]}
                            renderNoAccess={() => null}
                        >
                    <DataTable
                        columns={columns}
                        loading={dataState && dataState.loading}
                        data={dataState && dataState.response ? dataState.response.content : []}
                        countName="Disbursement(s)"
                        count={count}
                        defaultPageSize={10}
                        clearSearch={clearForm}
                        defaultPageNumber={1}
                        loadData={loadData}
                        error={dataState && dataState.error}
                        bordered={true}
                        striped={true}
                        hover={true}
                        responsive
                        tableName="disbursement"
                        customSearch={
                            <div>
                                <CustomSearch
                                    pageNumer={1}
                                    initialValues={{
                                        pageNum: 1,
                                        pageSize: 10,
                                        searchKey: ""
                                    }}
                                    pageSize={10}
                                    onSubmit={handleSubmit}
                                    placeholder="Search"
                                />
                                <Tabs onChange={onTabChange}>
                                    <div value="ALL" label="All"></div>
                                    <div value="PENDING" label="Pending"></div>
                                    <div value="APPROVED" label="Approved"></div>
                                    <div value="DECLINED" label="Declined"></div>
                                    <div value="REDRAFT" label="Redraft"></div>
                                </Tabs>
                                <br />
                            </div>
                        }
                        sortFn={sortFn}
                        searchKey={searchKey}
                        serverside
                    />
                       </AccessControl>
                    <DisbursementModal
                        disbursement={{}}
                        visible={showModal}
                        onClose={setShowModal}
                        id={disbursementInview}
                        reviewDisbursement={reviewDisbursement}
                        loader={loader}
                        setId={setDisbursementInview}
                    />
                </CardBody>
            </Card>
        </Col>
    );
});

export default connect((state) => ({
    disbursements: state.getDisbursement,
    viewDisbursement: state.viewDisbursement
}))(withRouter(DisbursementTable));